import { render, staticRenderFns } from "./goods-delete-apply-detail-modal.component.vue?vue&type=template&id=86b3e962"
import script from "./goods-delete-apply-detail-modal.component.vue?vue&type=script&lang=js"
export * from "./goods-delete-apply-detail-modal.component.vue?vue&type=script&lang=js"
import style0 from "./goods-delete-apply-detail-modal.component.vue?vue&type=style&index=0&id=86b3e962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports